module.exports = __webpack_public_path__ + "media/images/gallery/gc_m-e27a4a431279fcb7317850399c22206a.gif";